<app-card class="header">
  <div>
    <app-ribbon type="beta" />
    <h1 i18n class="title">Guidance data converter</h1>
    <p i18n>Seamlessly convert and reuse your guidance data across platforms and operations</p>
    <p i18n>
      Upload your field boundaries, guidance lines, and obstacles, and we'll convert them into the formats you need. We
      support a wide range of equipment, terminals, and field management systems, ensuring your guidance data moves
      smoothly between platforms. This makes it easier to reuse the same lines across different operations, improving
      consistency and efficiency in the field.
    </p>
  </div>
  <div>
    <div i18n>TRY IT OUT</div>
    <ul>
      <li>
        <app-bullet size="small">1</app-bullet>
        <span i18n>Upload a ZIP-file containing your guidance data (boundary, lines, objects)</span>
      </li>
      <li>
        <app-bullet size="small">2</app-bullet> <span i18n>Select the output format you want to convert it to</span>
      </li>
      <li><app-bullet size="small">3</app-bullet> <span i18n>Download the converted file in the new format</span></li>
    </ul>
    <p class="info-feedback">
      <span i18n>... and let us know what you think -</span>
      <app-link i18n target="_self" [href]="goToFeedback()">send your feedback</app-link>
    </p>
  </div>
</app-card>
<app-card class="upload">
  <app-card-title i18n-subtitle subtitle="Upload a ZIP-file containing your guidance data (boundary, lines, objects)">
    <div title class="upload-title">
      <h2 i18n>Select file</h2>
      <app-info-hover [wide]="true">
        <div>
          <span i18n>Field data must be in one of the supported formats shown below and uploaded as a ZIP file.</span>
          <div i18n class="formats-title">Supported formats:</div>
          <div class="formats-wrapper">
            @for (format of inputFormats(); track format) {
              <span>{{ format }}</span>
            }
          </div>
        </div>
      </app-info-hover>
    </div>
  </app-card-title>

  <form class="file-upload">
    <app-file-upload accept=".zip" (fileChange)="onFileSelected($event)">
      <div class="upload-info">
        <app-icon icon="upload" />
        <span i18n>Drag and drop or <span class="highlight">browse</span> your file</span>
      </div>
    </app-file-upload>
  </form>
</app-card>
<app-card class="format">
  <app-card-title
    i18n-title
    i18n-subtitle
    title="Select your output format & download"
    subtitle="Select the format you want to convert your guidance data to by selecting file format or your brand and terminal model."
  />
  <div class="format-wrapper">
    @if (!targets().generic.length && !targets().company.length) {
      <div class="loading">
        <div i18n>Loading formats</div>
      </div>
    } @else {
      <h3 i18n>File Format</h3>
      <div class="formats">
        @for (target of targets().generic; track target.name) {
          <app-guidance-item [item]="target" [isActive]="!!file()" (format)="upload($event)"></app-guidance-item>
        }
      </div>
      <h3 i18n>Brand and Terminal</h3>
      <div class="formats">
        @for (target of targets().company; track target.name) {
          <app-guidance-item [item]="target" [isActive]="!!file()" (format)="upload($event)"></app-guidance-item>
        }
      </div>
      @if (isConverting()) {
        <div i18n class="downloading">
          File is being converted<br />your download will start automatically once the conversion is complete.
        </div>
      }
    }
  </div>
</app-card>
<app-card class="feedback" id="feedback">
  <app-feedback-card
    i18n-subtitle
    subtitle="How likely are you to use this feature in its current form?"
    feature="guidance-data-converter"
  />
</app-card>
